import axios from 'axios';
const forceStaging = false;
export const apiUrl = (process.env.NODE_ENV === "development" && !forceStaging) ? "http://localhost:3030/api" : "https://2jxomyn08b.execute-api.us-east-1.amazonaws.com/staging/api"

const api = axios.create({
  baseURL: apiUrl,
});

const refreshToken = async (refreshToken: string) => {
  if (!refreshToken) {
    return null;
  }
  try {
    const response = await api.post('/auth/refresh-token', {
      headers: {
        'Authorization': `Bearer ${refreshToken}`
      }
    });
    return {
      accessToken: response.data.access_token,
      refreshToken: response.data.refresh_token,
    }
  } catch (error) {
    console.error('Error refreshing token:', error);
    return null;
  }
};

api.interceptors.request.use(
  config => {
    const storageToken = localStorage.getItem('token');
    if (storageToken) {
      const token = JSON.parse(storageToken);
      config.headers['Authorization'] = `Bearer ${token.refreshToken}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export { api, refreshToken };
